import ColumnSet from '@/components/grid/columns/column-set';
import columns from '@/common/definitions/columns/coupons';

export default new ColumnSet({
    id: 'coupon-list',
    ...columns,
});
